// Mock data for Ved Homestays

export const rooms = [
  {
    id: 'deluxe-1',
    name: 'Deluxe Room 1',
    type: 'Deluxe',
    price: 1500,
    bedType: 'Queen Size Bed',
    maxOccupancy: 5,
    baseOccupancy: 2,
    extraMattressCharge: 100,
    amenities: [
      'Queen Size Bed',
      'Air Conditioning',
      'Free WiFi',
      'Attached Bathroom',
      'Hot Water 24/7',
      'Room Service',
      'Extra Mattress Available'
    ],
    images: [
      'https://customer-assets.emergentagent.com/job_banarasi-living/artifacts/jrno0k2e_deluxe%20room%201.jpeg',
      'https://customer-assets.emergentagent.com/job_banarasi-living/artifacts/5o8nomyy_toilet.JPG'
    ],
    available: true,
    description: 'Spacious deluxe room with beautiful decor near Kashi Vishwanath Temple'
  },
  {
    id: 'premium-1',
    name: 'Standard Room',
    type: 'Standard',
    price: 1200,
    bedType: 'Queen Size Bed',
    maxOccupancy: 2,
    baseOccupancy: 2,
    extraMattressCharge: 0,
    amenities: [
      'Queen Size Bed',
      'Air Conditioning',
      'Free WiFi',
      'Attached Bathroom',
      'Hot Water 24/7',
      'Room Service',
      'Cozy & Comfortable'
    ],
    images: [
      'https://customer-assets.emergentagent.com/job_banarasi-living/artifacts/rli301qp_premium%20room.jpg',
      'https://customer-assets.emergentagent.com/job_banarasi-living/artifacts/5o8nomyy_toilet.JPG'
    ],
    available: true,
    description: 'Cozy standard room ideal for couples'
  },
  {
    id: 'ultra-large-1',
    name: 'Ultra-Large Room',
    type: 'Ultra-Large',
    price: 2500,
    bedType: '6 Single Beds',
    maxOccupancy: 10,
    baseOccupancy: 6,
    extraMattressCharge: 50,
    amenities: [
      '6 Single Beds',
      'Air Conditioning',
      'Free WiFi',
      'Attached Bathroom',
      'Hot Water 24/7',
      'Room Service',
      'Perfect for Groups',
      'Extra Mattress Available'
    ],
    images: [
      'https://customer-assets.emergentagent.com/job_banarasi-living/artifacts/4uztrsar_hall%20updated%20photo.jpg',
      'https://customer-assets.emergentagent.com/job_banarasi-living/artifacts/5o8nomyy_toilet.JPG'
    ],
    available: true,
    description: 'Large room perfect for groups and families visiting Varanasi'
  }
];

export const galleryImages = {
  varanasi: [
    {
      url: 'https://images.unsplash.com/photo-1706186839147-0d708602587b',
      caption: 'Ganga Ghat View'
    },
    {
      url: 'https://images.unsplash.com/photo-1561359313-0639aad49ca6',
      caption: 'Traditional Ghat Architecture'
    },
    {
      url: 'https://images.unsplash.com/photo-1561361058-c24cecae35ca',
      caption: 'Riverside Temple View'
    },
    {
      url: 'https://images.unsplash.com/photo-1734784566171-1c4cc78df1c1',
      caption: 'Boats on Ganges'
    },
    {
      url: 'https://images.unsplash.com/photo-1665413793087-d58c23e3a177',
      caption: 'Evening Ganga Aarti'
    },
    {
      url: 'https://images.pexels.com/photos/7919685/pexels-photo-7919685.jpeg',
      caption: 'Traditional Aarti Ceremony'
    },
    {
      url: 'https://images.unsplash.com/photo-1716573260891-23ad993e8833',
      caption: 'Fire Ceremony at Ghats'
    },
    {
      url: 'https://images.unsplash.com/photo-1645247603461-89777589fe3d',
      caption: 'Kashi Temple Architecture'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_banarasi-living/artifacts/kcy0ll7a_image%20of%20wall%20painting.JPG',
      caption: 'Traditional Wall Art at Ved Homestays'
    }
  ],
  deluxe: [
    {
      url: 'https://customer-assets.emergentagent.com/job_banarasi-living/artifacts/jrno0k2e_deluxe%20room%201.jpeg',
      caption: 'Deluxe Room - Elegant Interior'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_banarasi-living/artifacts/5o8nomyy_toilet.JPG',
      caption: 'Deluxe Room - Modern Bathroom'
    }
  ],
  premium: [
    {
      url: 'https://customer-assets.emergentagent.com/job_banarasi-living/artifacts/rli301qp_premium%20room.jpg',
      caption: 'Standard Room - Cozy Comfort'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_banarasi-living/artifacts/5o8nomyy_toilet.JPG',
      caption: 'Standard Room - Clean Bathroom'
    }
  ],
  'ultra-large': [
    {
      url: 'https://customer-assets.emergentagent.com/job_banarasi-living/artifacts/4uztrsar_hall%20updated%20photo.jpg',
      caption: 'Ultra-Large Room - Perfect for Groups'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_banarasi-living/artifacts/5o8nomyy_toilet.JPG',
      caption: 'Ultra-Large Room - Attached Bathroom'
    }
  ]
};

export const amenities = [
  {
    icon: 'Wifi',
    title: 'Free WiFi',
    description: 'High-speed internet throughout'
  },
  {
    icon: 'Wind',
    title: 'Air Conditioning',
    description: 'Climate controlled rooms'
  },
  {
    icon: 'Coffee',
    title: 'Room Service',
    description: 'Available 24/7'
  },
  {
    icon: 'Droplets',
    title: 'Hot Water',
    description: 'Round the clock hot water'
  },
  {
    icon: 'MapPin',
    title: 'Prime Location',
    description: 'Near Kashi Vishwanath Temple'
  },
  {
    icon: 'Map',
    title: 'Tour Arrangements',
    description: 'Guided Varanasi tours available'
  }
];

export const testimonials = [
  {
    name: 'Rajesh Kumar',
    location: 'Delhi',
    rating: 5,
    text: 'Amazing experience! The homestay is perfectly located near the ghats. The hosts made us feel like family.',
    date: 'December 2024'
  },
  {
    name: 'Priya Sharma',
    location: 'Mumbai',
    rating: 5,
    text: 'Truly lived like a Banarasi! The rooms are clean, comfortable and the hospitality is exceptional.',
    date: 'November 2024'
  },
  {
    name: 'David Wilson',
    location: 'London, UK',
    rating: 5,
    text: 'Best place to stay in Varanasi. Close to temples and ghats. Highly recommended for authentic experience.',
    date: 'October 2024'
  }
];

export const contactInfo = {
  phone: '+91 9984397001',
  phoneSecondary: '+91 7524809170',
  whatsapp: '+919984397001',
  email: 'vedhomestays@gmail.com',
  address: 'Near Kashi Vishwanath Temple, Ganga Ghat Road, Varanasi, Uttar Pradesh 221001',
  mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3607.373995582461!2d83.00836431501378!3d25.318634283844738!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x398e2f000df0b321%3A0x231ea313557649d3!2sVed%20Homestay!5e0!3m2!1sen!2sin!4v1234567890123!5m2!1sen!2sin',
  checkInTime: '11:00 AM',
  checkOutTime: '10:00 AM'
};
